import { useContext, useEffect, useState } from 'react';
import { AdminContext } from '../context/AdminContext';
import { UserContext } from '../context/UserContext';
import { styles, StyledFloatingButton, StyledTable, UserContainer, FiltrosContainer } from './components/usuariosComponents';
import { columns, customStyles, opcionesdepagina, } from './components/tableOptions';
import Card from '../components/Card/Card';
import CardHeader from '../components/Card/CardHeader';
import CardBody from '../components/Card/CardBody.js';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import { FcSearch } from 'react-icons/fc';
import Fab from '@mui/material/Fab';
import ModalUsuario from './components/modalUsuario';
import { useNavigate } from 'react-router-dom';
import Botones from './components/botenes';
import { CircleLoader } from 'react-spinners';
const useStyles = makeStyles(styles);

function Usuarios() {
  const classes = useStyles();
  const { handleClickSnackbar, setSelectedUser } = useContext(AdminContext);
  const { users, getUsers } = useContext(UserContext);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState(false);
  const [userSelection, setUserSelection] = useState(null);
  const [loading, setLoading] = useState(false);

  const history = useNavigate();

  function buscar(rows) {
    if (rows) {
      return rows.filter((row) =>
        row.nombreCompleto?.toString().toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        row.dni?.toString().toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        row.email?.toString().toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        row.identificador?.toString().toLowerCase().indexOf(search.toLowerCase()) > -1,
      );
    } else return [];
  }

  function toggleModal(mensaje, tipo) {
    if (mensaje && tipo) handleClickSnackbar(mensaje, tipo);
    if (modal) {
      setUserSelection(null);
    }
    setModal((prev) => (prev ? false : true));
  }

  async function loadUsers() {
    setLoading(true);
    await getUsers();
    setLoading(false);
  }

  function verBalance(row) {
    setSelectedUser(row);
    history('/cuentas', { replace: true });
  }

  function verProductos(row) {
    setSelectedUser(row);
    history('/productos', { replace: true });
  }

  function ModificarUsuario(selectedItem) {
    setUserSelection(selectedItem);
    toggleModal();
  }

  useEffect(() => {
    setData([...users]);
  }, [users]);

  useEffect(() => {
    if (data.length === 0) {
      loadUsers();
    }
  }, []);

  return (
    <UserContainer>
      <CircleLoader loading={loading} cssOverride={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
      <ModalUsuario
        modal={modal}
        toggleModal={toggleModal}
        userSelection={userSelection}
      />
      <Card>
        <CardHeader color='info'>
          <h2 className={classes.cardTitleWhite}>Usuarios</h2>
          <p className={classes.cardCategoryWhite}>
            Listado de compradores y proveedores registrados en el sistema
          </p>
        </CardHeader>
        <CardBody>
          <FiltrosContainer>
            <TextField
              variant="outlined"
              label='Buscar'
              id='Buscar'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                endAdornment: <FcSearch />,
              }} />
{/* ----------------------------------------------- EXCEL EXPORT -----------------------------------------------*/}
            {data.length !== 0 ? <Botones data={data} /> : null}
          </FiltrosContainer>
          <StyledTable
            title=''
            columns={columns(verBalance, verProductos)}
            data={buscar(data)}
            customStyles={customStyles}
            pagination
            keyField='id'
            paginationComponentOptions={opcionesdepagina}
            paginationRowsPerPageOptions={[10, 25, 50, 100, 500, 800, 1000]}
            fixedHeader
            fixedHeaderScrollHeight='600px'
            highlightOnHover
            responsive
            onRowClicked={(selectedItem) => {
              ModificarUsuario(selectedItem);
            }}
            noDataComponent={
              <div>No hay informacion disponible para mostrar</div>
            }
          />
        </CardBody>
      </Card>
      <StyledFloatingButton>
        <Fab
          color='primary'
          aria-label='add'
          onClick={() => {
            toggleModal();
          }}>
          +
        </Fab>
      </StyledFloatingButton>
    </UserContainer>
  );
}

export default Usuarios;
